import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
export function HeroSection() {
  return <section id="top" className="flex min-h-[calc(100svh-2.25rem)] items-center bg-brand-main px-4 py-8 text-center md:py-10" data-id="element-84" data-mp="2hvm4m8t8rmbp">
      <motion.div initial={{
      opacity: 0,
      y: 18
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.58
    }} className="mx-auto flex w-full max-w-4xl flex-col items-center justify-center" data-id="element-85" data-mp="23xe82204an12">
        <p className="text-[10px] font-extrabold uppercase tracking-[0.22em] text-brand-orange sm:text-xs" data-id="element-86" data-mp="30lk9yh5nn1bn">
          Das komplette Musik-Curriculum
        </p>
        <h1 className="mt-3 max-w-3xl text-[1.9rem] font-extrabold leading-[1.08] tracking-tight text-brand-navy sm:text-[2.6rem] md:text-[3rem]" data-id="element-87" data-mp="2ms31breib90e">
          Unterrichte ein ganzes Jahr{' '}
          <span className="font-script italic text-brand-orange" data-id="element-88" data-mp="3fgi51hs6u4wf">Musik</span> in
          nur 5 Minuten Vorbereitung
        </h1>
        <p className="mx-auto mt-3 max-w-2xl text-[13px] leading-relaxed text-brand-gray sm:text-[15px]" data-id="element-89" data-mp="2ff8u4tarc6vf">
          Musik Startklar ist ein komplettes, fertiges Musik-Curriculum — 10
          Hefte voller sofort einsetzbarer Stunden, praktischer Aktivitäten und
          Lernkontrollen, von Klasse 1 bis Klasse 9. Einfach ausdrucken,
          aufschlagen und loslegen.
        </p>
        <img src="https://cdn.magicpatterns.com/uploads/or958DkeFN1kFaHaVytFa9/ChatGPT_Image_11_ago_2026,_20_22_08-Photoroom.png" alt="Musik Startklar Komplettpaket: 10 Arbeitshefte Band 1 bis 10, digitale Unterrichtsabläufe und 5 Bonus-Hefte" className="mx-auto my-4 h-[34svh] w-auto max-w-full object-contain sm:my-5 sm:h-[38svh]" data-id="element-90" data-mp="2z3hnv7ry8kx1" />
        <CTAButton animated className="px-8 py-3.5" data-id="element-91" data-mp="335w3lj0bn4k3" />
        <p className="mt-3 text-[11px] font-semibold text-brand-gray sm:text-xs" data-id="element-92" data-mp="1dpd7u7w3y2k3">
          Sofort-Download <span className="px-1 text-brand-orange" data-id="element-93" data-mp="18rv7v702ixo8">·</span>{' '}
          Sichere Bezahlung <span className="px-1 text-brand-orange" data-id="element-94" data-mp="38tl1hid04jv9">·</span> 30
          Tage Geld-zurück-Garantie
        </p>
      </motion.div>
    </section>;
}